import { useState } from "react";
import { apiURL } from "../../../consts/URLs";
import { LOGOUT } from "../../endpointList";
import { fetchRequest, getOptions } from "../../utils";

const useLogout = (token: string | null) => {
  const [logoutResponse, setLogoutResponse] = useState<any>();
  const [logoutResult, setLogoutResult] = useState<any>();

  const logout = () => {
    const url = `${apiURL}/${LOGOUT}`;
    const options = getOptions({
      method: "GET", 
      token: token,
    });
    fetchRequest(url, options, setLogoutResponse, setLogoutResult);
  };

  return { logoutResponse, logoutResult, logout };
};
export default useLogout;
